/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required, stringLength, numericRange } from '@mhub/web-validations';
import AppForm from '../AppForm';
import { PROJECT_UNIT_PACKAGE_PRICING_DEFAULT } from '../../structs/package_pricing';

export default class UnitPackagePricingEdit extends Component {
  static propTypes = {
    data: PropTypes.shape(),
    onChange: PropTypes.func,
    packagePricings: PropTypes.func,
    refForm: PropTypes.func,
    refValidation: PropTypes.func,
  }
  static defaultProps = {
    data: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
  }
  handleSave = (e) => {
    if (e) e.preventDefault();
    const { data } = this.props;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleInputChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = d.value;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleCheckboxChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = !data[d.name];
    if (data[d.name]) {
      if (data.id === '') data.projectPackagePricingID = '';
      data.totalPrice = '';
      data.customName = '';
      data.customDescription = '';
    }
    if (this.props.onChange) this.props.onChange(data);
  }
  render() {
    const { data } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <AppForm
              as="div"
              onSubmit={this.handleSave}
              ref={this.props.refForm}
            >
              <Grid>
                {/* Enable & Package/Custom Price */}
                <Grid.Row verticalAlign="middle" className="row_enable_package_custom_price">
                  <Grid.Column mobile={16} tablet={12} computer={13}>
                    {(data.id !== '' && data.projectPackagePricingID !== '') ?
                      <span>
                        <span className="text_name">{data.projectPackagePricing.name}{data.projectPackagePricing.description !== '' ? ': ' : ''}</span>
                        {data.projectPackagePricing.description !== '' ? <span className="text_description">{data.projectPackagePricing.description}</span> : ''}
                      </span>
                      : ''
                    }
                    <AppForm.Input
                      name="totalPrice"
                      onChange={this.handleInputChange}
                      placeholder="Custom Amount"
                      ref={this.props.refValidation}
                      step=".01"
                      type="number"
                      validateLabel="Custom Amount"
                      validation={data.isCustomPrice ? [required, {
                        validate: numericRange,
                        option: {
                          min: 0.01,
                          max: 2147483647,
                        },
                      }] : null}
                      value={data.totalPrice}
                      style={data.isCustomPrice ? {} : { display: 'none' }}
                    />
                    <AppForm.Validate
                      name="projectPackagePricingID"
                      onChange={this.handleInputChange}
                      ref={this.props.refValidation}
                      validateLabel="Pricing Package"
                      validation={(!data.isCustomPrice && data.id === '') ? [required] : null}
                      style={(!data.isCustomPrice && data.id === '') ? {} : { display: 'none' }}
                    >
                      <Form.Select
                        fluid
                        name="projectPackagePricingID"
                        options={this.props.packagePricings()}
                        placeholder="Select Pricing Package"
                        search
                        selectOnBlur
                        value={data.projectPackagePricingID}
                      />
                    </AppForm.Validate>
                  </Grid.Column>
                </Grid.Row>
                {/* Name & Description */}
                <Grid.Row className="row_name_desc" style={(data.isCustomPrice && data.projectPackagePricingID === '') ? {} : { display: 'none' }}>
                  <Grid.Column mobile={16} tablet={6} computer={6}>
                    <AppForm.Input
                      placeholder="Custom Name"
                      name="customName"
                      onChange={this.handleInputChange}
                      ref={this.props.refValidation}
                      type="text"
                      validateLabel="Custom Name"
                      validation={(data.isCustomPrice && data.projectPackagePricingID === '') ? [required, {
                        validate: stringLength,
                        option: {
                          max: 128,
                        },
                      }] : null}
                      value={data.customName}
                    />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={10} computer={10}>
                    <AppForm.Input
                      placeholder="Custom Description"
                      name="customDescription"
                      onChange={this.handleInputChange}
                      ref={this.props.refValidation}
                      type="text"
                      validateLabel="Custom Description"
                      value={data.customDescription}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </AppForm>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectUnitPackagePricing/UnitPackagePricingEdit.jsx